export const RATING_TEXTS = {
  1: 'Нельзя иметь дело',
  2: 'Не рекомендую',
  3: 'Можно и лучше',
  4: 'Почти нет вопросов',
  5: 'Всё отлично',
};
